export default __webpack_public_path__ + "static/media/ic-icon-pay.07503527.png";